/* global axios */
import ApiClient from '../ApiClient';

// CPF duplicado entre canais (Bloco 3 / T-12). get() detecta (contatos com o mesmo CPF +
// conversas ativas); notar() garante a nota privada cross-canal (idempotente).
class CpfMatchAPI extends ApiClient {
  constructor() {
    super('fandata/conversations', { accountScoped: true });
  }

  get(conversationDisplayId) {
    return axios.get(`${this.url}/${conversationDisplayId}/cpf_match`);
  }

  notar(conversationDisplayId) {
    return axios.post(`${this.url}/${conversationDisplayId}/cpf_match`);
  }
}

export default new CpfMatchAPI();
